import React, { createContext, useContext, useEffect, useState } from 'react';
import { API_KEY, API_LOGIN_URL, API_REGISTER_URL } from '../constants';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(sessionStorage.getItem('kepithor_auth')) || null;
    } catch {
      return null;
    }
  });

  const login = async (email, password) => {
    const form = new URLSearchParams();
    form.set('email', email);
    form.set('password', password);
    form.set('api_key', API_KEY);

    const res = await fetch(API_LOGIN_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: form.toString(),
      credentials: 'include',
      mode: 'cors'
    });
    if (!res.ok) throw new Error(`Login failed (${res.status})`);
    const data = await res.json();
    if (data.response === 'loginSuccessFul') {
      const auth = {
        email: data.email,
        id: data.id,
        session: data.session,
        hash: data.hash,
        displayname: data.displayname
      };
      sessionStorage.setItem('kepithor_auth', JSON.stringify(auth));
      setUser(auth);
      return { ok: true, data: auth };
    }
    throw new Error(data.error || 'Invalid credentials');
  };

  const register = async (email, password, username) => {
    if (!email || !password || !username) throw new Error('All fields are required.');
    if (password.length > 30) throw new Error('Password must be 30 characters or fewer.');

    const form = new URLSearchParams();
    form.set('email', email);
    form.set('password', password);
    form.set('username', username);
    form.set('api_key', API_KEY);

    const res = await fetch(API_REGISTER_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: form.toString(),
      credentials: 'include',
      mode: 'cors'
    });
    if (!res.ok) throw new Error(`Registration failed (${res.status})`);

    let data = null;
    try { data = await res.json(); } catch { /* ok if not json */ }
    if (data && data.error) throw new Error(data.error);
    return { ok: true, data };
  };

  // ⭐ NEW: helper used by Google login
  const loginWithGoogle = (googleUser) => {
    if (!googleUser) return null;

    const auth = {
      email: googleUser.email,
      id: googleUser.id,
      session: googleUser.session,
      hash: googleUser.hash,
      displayname: googleUser.displayname
    };

    sessionStorage.setItem('kepithor_auth', JSON.stringify(auth));
    setUser(auth);
    return auth;
  };

  const logout = () => {
    sessionStorage.removeItem('kepithor_auth');
    setUser(null);
    window.location.assign('/');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, register, loginWithGoogle }}>
      {children}
    </AuthContext.Provider>
  );
};
